export default "__VITE_ASSET__uzk5eirX__"